import { createElement } from 'react';
import { Drawer as OriginalDrawer, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import 'antd/dist/antd.variable.min.css';
import '../../variables.scss';
const Drawer = (props) => {
    ConfigProvider.config({
        theme: {
            primaryColor: '#f16622',
        },
    });
    const innerProps = {};
    if (props.__designmode === 'design') {
        // 低代码编辑态中强制显示，将控制权交给引擎侧
        innerProps.open = true;
    }
    return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
        createElement(OriginalDrawer, { ...props, ...innerProps })));
};
export default Drawer;
